import { logError } from "./logs";

export default function isEmpty(str: string | number | boolean | undefined) {
  try {
    if (typeof str === 'string') {
      if (str.replace(/\s/g, '')) {
        return false;
      }
      return true;
    }
    return !str;
  } catch (err) {
    logError(err as Error);
    return true;
  }
}
